import React from "react";
import { ArrowUpRight, ArrowDownRight, Trash2, Pencil } from "lucide-react";
import { toast } from "sonner";
import api, { TRY, trDate, formatApiError, weekendRow } from "@/lib/api";
import { Card } from "@/components/Cards";

export default function StaffLedgerTable({ txns, onChanged, onEdit }) {
  const del = async (id) => {
    try { await api.delete(`/staff-ledger/${id}`); toast.success("İşlem silindi"); onChanged(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const H = ["Tarih", "Personel", "İşlem", "Yöntem", "Hakediş (Borç)", "Ödeme", ""];
  return (
    <Card className="overflow-hidden" data-testid="staff-ledger-table">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border bg-muted/40 text-left">
              {H.map((h, i) => <th key={i} className={`px-4 py-3 text-xs font-semibold uppercase tracking-wider text-muted-foreground ${i === 4 || i === 5 ? "text-right" : ""}`}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {txns.length === 0 ? (
              <tr><td colSpan={7} className="px-4 py-12 text-center text-muted-foreground">Hareket bulunamadı</td></tr>
            ) : txns.map((t) => (
              <tr key={t.id} data-testid={`staff-txn-row-${t.id}`} className={"border-b border-border/60 hover:bg-accent/40 transition-colors" + weekendRow(t.date)}>
                <td className="px-4 py-3 font-mono text-xs text-muted-foreground whitespace-nowrap">{trDate(t.date)}</td>
                <td className="px-4 py-3 font-medium">{t.staff_name}</td>
                <td className="px-4 py-3">
                  <span className={`inline-flex items-center gap-1.5 text-xs font-medium ${t.type === "accrual" ? "text-rose-400" : "text-emerald-400"}`}>
                    {t.type === "accrual" ? <ArrowUpRight className="h-3.5 w-3.5" /> : <ArrowDownRight className="h-3.5 w-3.5" />}
                    <span className="font-semibold">{t.category}</span>{t.description && t.description !== t.category && <span className="text-muted-foreground">· {t.description}</span>}
                  </span>
                </td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{t.method || "—"}</td>
                <td className="px-4 py-3 text-right font-mono">{t.type === "accrual" ? TRY(t.amount) : "—"}</td>
                <td className="px-4 py-3 text-right font-mono text-emerald-400">{t.type === "payment" ? TRY(t.amount) : "—"}</td>
                <td className="px-4 py-3 text-right">
                  {onEdit && <button onClick={() => onEdit(t)} data-testid={`staff-txn-edit-${t.id}`} title="Düzelt" className="h-7 w-7 mr-1 rounded-md hover:bg-accent inline-flex items-center justify-center text-muted-foreground hover:text-foreground"><Pencil className="h-3.5 w-3.5" /></button>}
                  <button onClick={() => del(t.id)} data-testid={`staff-txn-delete-${t.id}`} className="h-7 w-7 rounded-md hover:bg-destructive/10 inline-flex items-center justify-center text-muted-foreground hover:text-destructive"><Trash2 className="h-3.5 w-3.5" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
